import { FormattedMessage } from 'react-intl';

import { REQUIREMENT_STEP_PATHS } from '../../../../requirementStepPaths';
import { TRequirementProps } from '../../fundingRequirements.types';
import { CompletedRequirementItem } from '../CompletedRequirementItem/CompletedRequirementItem';
import { InReviewRequirementItem } from '../InReviewRequirementItem/InReviewRequirementItem';
import { RequirementItem } from '../RequirementItem/RequirementItem';

const Title = () => (
    <FormattedMessage
        id="_.funding_requirements_v2.type.id_verification"
        defaultMessage="Verify your identity"
    />
);

export const IdVerificationRow = ({ status }: TRequirementProps) => {
    switch (status) {
        case 'in_review':
            return <InReviewRequirementItem title={<Title />} />;
        case 'completed':
            return <CompletedRequirementItem title={<Title />} />;
        case 'action_needed':
        case 'error':
        default:
            return (
                <RequirementItem
                    title={<Title />}
                    estimatedTime={
                        <FormattedMessage
                            id="_.funding_requirements_v2.time.5_min"
                            defaultMessage="~ 5 Min."
                        />
                    }
                    href={REQUIREMENT_STEP_PATHS.id_verification}
                />
            );
    }
};
